import axios from 'axios';
import Common from './Common';
export default {
    getAll() {
        return axios.get(Common.api + 'seller-login');
    },
    getRegistration1(){
        return axios.get(Common.api + 'seller-reg-first');
    },
    create(data){
        return axios.post(Common.api+'seller-login',data);
    },
    createResgistration1(data){
        return axios.post(Common.api + 'seller-reg-first', data);
    },
    createResgistration2(data){
        return axios.post(Common.api + 'seller-reg-second', data);
    },
    checkEmail(data){
        return axios.post(Common.api + 'check-mail', data);
    },
    update(id,data){
        return axios.put(Common.api+'seller-login'+id,data);
    }
}